//modules
import React, { useEffect, useRef } from 'react';
import { StuffCard } from './StuffCard';
import { useTextAnimation } from '../globalComponents/UseTextAnimation';
import { RightsFooter } from './RightsFooter';
import { useTransition } from '../globalComponents/PageTransitionContext';

//styles
import './ProjectsFooter.css';

export const ProjectsFooter = ({ StuffData }) => {

  const { handleNavigation } = useTransition();
  const { textRef } = useTextAnimation();
  const footerRef = useRef(null);
  const carouselRef = useRef(null);

useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel) return;

    // Desktop: convert vertical wheel to horizontal
    const handleWheel = (e) => {
        const isVertical = Math.abs(e.deltaY) > Math.abs(e.deltaX);
        if (!isVertical) return;
        e.preventDefault();
        const sensitivity = 2.5;
        const delta = Math.sign(e.deltaY) * Math.max(Math.abs(e.deltaY) * sensitivity, 8);
        carousel.scrollLeft += delta;
    };

    // Mobile: handle touch swipe
    let touchStartX = 0;
    let touchStartScrollLeft = 0;

    const onTouchStart = (e) => {
        touchStartX = e.touches[0].clientX;
        touchStartScrollLeft = carousel.scrollLeft;
    };

    const onTouchMove = (e) => {
        const diff = (touchStartX - e.touches[0].clientX) * 3;
        carousel.scrollLeft = touchStartScrollLeft + diff;
    };

    carousel.addEventListener("wheel", handleWheel, { passive: false });
    carousel.addEventListener("touchstart", onTouchStart, { passive: true });
    carousel.addEventListener("touchmove", onTouchMove, { passive: true });

    return () => {
        carousel.removeEventListener("wheel", handleWheel);
        carousel.removeEventListener("touchstart", onTouchStart);
        carousel.removeEventListener("touchmove", onTouchMove);
    };
}, []);


  return (
    <div className="footer-container" ref={footerRef}>
      <div className="footer-heading">
        <p className="heading-5" ref={(el) => (textRef.current[0] = el)}>I’m not out of ideas yet.</p>
        <h2 className="heading-2" ref={(el) => (textRef.current[1] = el)}>See what else I’ve done:</h2>
      </div>

      <div className="footer-carousel" ref={carouselRef}>
        {StuffData.map((data, index) => (
          <StuffCard
            key={index}
            title={data[0]}
            description={data[1]}
            image={data[2]}
            path={data[3]}
            customClass="custom-class"
            isExternal={false}
            onClick={() => handleNavigation(data[3])}
            role="button"
            style={{ cursor: 'pointer' }}
          />
        ))}
      </div>

      <RightsFooter customClass= "rights-footer-custom-class" />
    </div>
  );
};
